/**
 * Suggested product categories for each industry (the business type's main category).
 *
 * Each sub category is offered once in the product Category dropdown, with its products listed under it.
 */
export const INDUSTRY_CATEGORY_SUGGESTIONS: { [industry: string]: { [subCategory: string]: string[] } } = {
  'Fashion & Clothing': {
    "Men's Clothing": ['T-Shirts', 'Dress Shirts', 'Polo Shirts', 'Jeans', 'Trousers', 'Shorts', 'Hoodies & Sweatshirts', 'Jackets & Coats', 'Suits & Blazers'],
    "Women's Clothing": ['Tops & Blouses', 'Dresses', 'Skirts', 'Jeans', 'Leggings', 'Sweaters & Cardigans', 'Jackets & Coats', 'Jumpsuits & Rompers'],
    'Kids & Baby Clothing': ['Kids T-Shirts', 'Kids Dresses', 'Kids Pants & Shorts', 'Baby Bodysuits', 'Baby Sleepwear'],
    'Traditional Wear': ['Shalwar Kameez', 'Kurtas', 'Abayas', 'Sarees', 'Lehengas'],
    'Activewear & Swimwear': ['Activewear Sets', 'Sports Bras', 'Yoga Pants', 'Swimsuits', 'Swim Trunks'],
    'Underwear & Sleepwear': ['Underwear', 'Bras', 'Pajamas', 'Robes', 'Thermal Wear'],
    'Socks & Hosiery': ['Socks', 'Tights', 'Stockings']
  },
  'Shoes & Footwear': {
    "Men's Shoes": ['Dress Shoes', 'Loafers', 'Casual Shoes', 'Boots'],
    "Women's Shoes": ['Heels & Pumps', 'Flats', 'Boots', 'Wedges'],
    "Kids' Shoes": ['Kids Sneakers', 'Kids Sandals', 'School Shoes'],
    'Sandals & Slippers': ['Sandals', 'Flip-Flops', 'Slides', 'House Slippers'],
    'Work & Safety Shoes': ['Work Boots', 'Safety Shoes', 'Rain Boots']
  },
  'Beauty & Cosmetics': {
    Makeup: ['Foundation', 'Lipstick', 'Mascara', 'Eyeshadow', 'Eyeliner', 'Blush'],
    'Skin Care': ['Face Wash', 'Moisturizer', 'Serum', 'Sunscreen', 'Face Mask'],
    'Hair Care': ['Shampoo', 'Conditioner', 'Hair Oil', 'Hair Color', 'Styling Products'],
    Fragrance: ['Perfume', 'Cologne', 'Body Spray'],
    'Bath & Body': ['Body Wash', 'Body Lotion', 'Soap', 'Deodorant'],
    'Nail Care': ['Nail Polish', 'Nail Polish Remover', 'Manicure Tools'],
    'Beauty Tools': ['Makeup Brushes', 'Hair Dryers', 'Straighteners', 'Mirrors']
  },
  'Nutrition & Wellness': {
    'Protein & Sports Nutrition': ['Protein Powder', 'Protein Bars', 'Pre-Workout', 'Creatine', 'BCAAs'],
    'Weight Management': ['Meal Replacement Shakes', 'Weight Gainers', 'Fat Burners', 'Diet Teas'],
    'Health Foods & Superfoods': ['Greens Powder', 'Chia & Flax Seeds', 'Oats & Granola', 'Honey & Natural Sweeteners'],
    'Herbal & Natural Remedies': ['Herbal Teas', 'Essential Oils', 'Herbal Tinctures'],
    'Wellness Drinks': ['Electrolyte Drinks', 'Kombucha', 'Energy Drinks']
  },
  'Vitamins & Supplements': {
    Vitamins: ['Multivitamins', 'Vitamin C', 'Vitamin D', 'Vitamin B Complex', 'Vitamin E'],
    Minerals: ['Magnesium', 'Zinc', 'Iron', 'Calcium', 'Potassium'],
    'Herbal Supplements': ['Ashwagandha', 'Turmeric', 'Ginseng', 'Green Tea Extract'],
    'Digestive Health': ['Probiotics', 'Digestive Enzymes', 'Fiber Supplements'],
    'Omega & Oils': ['Fish Oil', 'Omega-3', 'Cod Liver Oil', 'Flaxseed Oil'],
    'Beauty & Joint Support': ['Collagen', 'Biotin', 'Glucosamine', 'Hyaluronic Acid']
  },
  'Electronics & Accessories': {
    Audio: ['Headphones', 'Earbuds', 'Bluetooth Speakers', 'Soundbars'],
    'Computers & Laptops': ['Laptops', 'Desktop Computers', 'Tablets', 'Monitors'],
    'Cameras & Photography': ['Digital Cameras', 'Action Cameras', 'Tripods', 'Camera Bags'],
    'TV & Home Entertainment': ['Televisions', 'Streaming Devices', 'Projectors', 'Remote Controls'],
    'Smart Home & Wearables': ['Smart Watches', 'Fitness Trackers', 'Smart Plugs', 'Security Cameras'],
    'Computer Accessories': ['Keyboards', 'Mice', 'Webcams', 'USB Hubs', 'Laptop Stands']
  },
  'Mobile & Tech Accessories': {
    'Phone Cases & Covers': ['Phone Cases', 'Wallet Cases', 'Tablet Cases'],
    'Chargers & Cables': ['Wall Chargers', 'Car Chargers', 'USB Cables', 'Wireless Chargers'],
    'Screen Protectors': ['Tempered Glass', 'Privacy Screen Protectors', 'Camera Lens Protectors'],
    'Power Banks': ['Power Banks', 'Solar Chargers'],
    'Phone Holders & Mounts': ['Car Mounts', 'Ring Holders', 'Tripod Mounts'],
    'Memory & Storage': ['Memory Cards', 'USB Flash Drives', 'External Hard Drives']
  },
  'Jewelry & Accessories': {
    Jewelry: ['Necklaces', 'Earrings', 'Bracelets', 'Rings', 'Jewelry Sets'],
    Watches: ["Men's Watches", "Women's Watches", 'Kids Watches'],
    'Bags & Wallets': ['Handbags', 'Backpacks', 'Wallets', 'Tote Bags', 'Clutches'],
    'Hats, Scarves & Gloves': ['Caps', 'Beanies', 'Scarves', 'Gloves', 'Hijabs'],
    'Belts & Sunglasses': ['Belts', 'Sunglasses', 'Reading Glasses'],
    'Hair Accessories': ['Hair Clips', 'Headbands', 'Scrunchies']
  },
  'Toys & Games': {
    'Action Figures & Dolls': ['Action Figures', 'Dolls', 'Plush Toys', 'Playsets'],
    'Puzzles & Board Games': ['Jigsaw Puzzles', 'Board Games', 'Card Games'],
    'Educational Toys': ['Building Blocks', 'STEM Kits', 'Learning Toys'],
    'Outdoor Toys': ['Water Toys', 'Ride-On Toys', 'Sports Toys'],
    'Remote Control Toys': ['RC Cars', 'Drones', 'RC Helicopters'],
    'Baby & Toddler Toys': ['Rattles', 'Teething Toys', 'Stacking Toys']
  },
  'Books & Stationery': {
    Books: ['Fiction', 'Non-Fiction', "Children's Books", 'Textbooks', 'Religious Books'],
    'Notebooks & Journals': ['Notebooks', 'Diaries', 'Planners'],
    'Writing Supplies': ['Pens', 'Pencils', 'Markers', 'Highlighters'],
    'Office Supplies': ['Folders & Files', 'Staplers', 'Sticky Notes', 'Printer Paper'],
    'School Supplies': ['Backpacks', 'Geometry Sets', 'Calculators', 'Lunch Boxes']
  },
  'Sports & Fitness': {
    'Gym & Exercise Equipment': ['Dumbbells', 'Barbells', 'Weight Plates', 'Benches', 'Resistance Bands'],
    'Yoga & Pilates': ['Yoga Mats', 'Yoga Blocks', 'Pilates Balls'],
    'Cardio Equipment': ['Treadmills', 'Exercise Bikes', 'Jump Ropes'],
    'Fitness Accessories': ['Gym Gloves', 'Water Bottles', 'Gym Bags', 'Lifting Straps'],
    'Recovery & Support': ['Foam Rollers', 'Massage Guns', 'Knee & Wrist Supports']
  },
  'Home & Furniture': {
    'Living Room Furniture': ['Sofas', 'Coffee Tables', 'TV Stands', 'Bookshelves'],
    'Bedroom Furniture': ['Beds', 'Dressers', 'Nightstands', 'Wardrobes'],
    'Office Furniture': ['Desks', 'Office Chairs', 'Filing Cabinets'],
    'Mattresses & Bedding': ['Mattresses', 'Pillows', 'Bed Sheets', 'Comforters'],
    'Storage & Organization': ['Shelves', 'Storage Boxes', 'Shoe Racks'],
    'Outdoor Furniture': ['Patio Sets', 'Outdoor Chairs', 'Hammocks']
  },
  'Kitchen & Dining': {
    Cookware: ['Pots & Pans', 'Frying Pans', 'Pressure Cookers', 'Woks'],
    Bakeware: ['Baking Trays', 'Cake Pans', 'Muffin Pans'],
    'Kitchen Tools & Gadgets': ['Knives', 'Cutting Boards', 'Peelers & Graters', 'Measuring Cups'],
    'Dinnerware & Serveware': ['Plates', 'Bowls', 'Serving Dishes', 'Cutlery Sets'],
    Drinkware: ['Mugs', 'Glasses', 'Water Bottles', 'Tea Sets'],
    'Small Appliances': ['Blenders', 'Toasters', 'Electric Kettles', 'Air Fryers', 'Microwaves'],
    'Food Storage': ['Containers', 'Lunch Boxes', 'Thermos Flasks']
  },
  'Grocery & Food': {
    'Fresh Produce': ['Fruits', 'Vegetables', 'Herbs'],
    'Dairy & Eggs': ['Milk', 'Cheese', 'Yogurt', 'Eggs', 'Butter'],
    'Meat & Seafood': ['Chicken', 'Beef', 'Lamb', 'Fish'],
    Bakery: ['Bread', 'Cakes', 'Cookies'],
    'Pantry Staples': ['Rice', 'Flour', 'Cooking Oil', 'Spices', 'Lentils & Beans'],
    'Frozen Foods': ['Frozen Vegetables', 'Frozen Meals', 'Ice Cream'],
    Beverages: ['Tea', 'Coffee', 'Juices', 'Soft Drinks', 'Water']
  },
  'Pet Supplies': {
    'Dog Supplies': ['Dog Food', 'Dog Treats', 'Dog Toys', 'Leashes & Collars', 'Dog Beds'],
    'Cat Supplies': ['Cat Food', 'Cat Litter', 'Cat Toys', 'Scratching Posts'],
    'Fish & Aquarium': ['Fish Food', 'Aquariums', 'Filters & Pumps'],
    'Bird Supplies': ['Bird Food', 'Cages', 'Bird Toys'],
    'Small Pet Supplies': ['Rabbit Food', 'Hamster Cages', 'Small Pet Bedding'],
    'Pet Grooming & Health': ['Pet Shampoo', 'Brushes', 'Flea & Tick Care']
  },
  'Tools & Hardware': {
    'Hand Tools': ['Hammers', 'Screwdrivers', 'Wrenches', 'Pliers', 'Tape Measures'],
    'Power Tools': ['Drills', 'Saws', 'Grinders', 'Sanders'],
    Electrical: ['Light Bulbs', 'Extension Cords', 'Switches & Outlets', 'Batteries'],
    Plumbing: ['Pipes & Fittings', 'Faucets', 'Hoses'],
    'Paint & Supplies': ['Paint', 'Brushes & Rollers', 'Tape', 'Sealants'],
    'Fasteners & Hardware': ['Screws', 'Nails', 'Bolts & Nuts', 'Hinges', 'Locks'],
    'Garden Tools': ['Shovels', 'Pruners', 'Lawn Mowers', 'Watering Equipment']
  },
  'Gifts & Specialty Items': {
    'Gift Sets & Baskets': ['Gift Baskets', 'Gift Boxes', 'Gift Cards'],
    'Greeting Cards & Wrapping': ['Greeting Cards', 'Wrapping Paper', 'Gift Bags'],
    'Party Supplies': ['Balloons', 'Party Decorations', 'Disposable Tableware'],
    'Seasonal & Holiday': ['Eid Items', 'Christmas Items', 'Ramadan Items', 'Diwali Items'],
    'Personalized Gifts': ['Custom Mugs', 'Engraved Items', 'Photo Frames'],
    'Novelty Items': ['Keychains', 'Souvenirs', 'Magnets']
  },
  'Arts & Crafts': {
    'Painting & Drawing': ['Paints', 'Brushes', 'Canvases', 'Sketchbooks', 'Colored Pencils'],
    'Craft Supplies': ['Glue & Adhesives', 'Beads', 'Paper & Cardstock', 'Craft Kits'],
    'Sewing & Knitting': ['Fabric', 'Yarn', 'Sewing Machines', 'Needles & Thread'],
    'Scrapbooking & Stamps': ['Stickers', 'Stamps', 'Albums'],
    'Kids Craft Kits': ['Clay & Dough', 'Coloring Books', 'DIY Kits']
  },
  'Home Décor & Lifestyle': {
    'Wall Art & Mirrors': ['Wall Art', 'Wall Clocks', 'Mirrors', 'Photo Frames'],
    Lighting: ['Table Lamps', 'Floor Lamps', 'Chandeliers', 'String Lights'],
    'Candles & Fragrances': ['Candles', 'Incense', 'Air Fresheners', 'Diffusers'],
    'Rugs, Curtains & Cushions': ['Rugs', 'Curtains', 'Cushions', 'Throws & Blankets'],
    'Vases & Decorative Accents': ['Vases', 'Figurines', 'Artificial Plants', 'Decorative Trays']
  },
  'Sporting Goods': {
    'Team Sports': ['Cricket Equipment', 'Football', 'Basketball', 'Volleyball', 'Hockey'],
    'Outdoor & Camping': ['Tents', 'Sleeping Bags', 'Backpacks', 'Flashlights'],
    'Racquet Sports': ['Badminton Rackets', 'Tennis Rackets', 'Table Tennis', 'Squash'],
    Fishing: ['Fishing Rods', 'Reels', 'Tackle'],
    Cycling: ['Bicycles', 'Helmets', 'Bike Accessories'],
    'Water Sports': ['Swim Goggles', 'Life Jackets', 'Snorkel Sets'],
    Golf: ['Golf Clubs', 'Golf Balls', 'Golf Bags']
  },
  'Grocery & Convenience': {
    'Snacks & Candy': ['Chips', 'Chocolates', 'Candy', 'Biscuits & Cookies', 'Nuts'],
    'Drinks & Energy': ['Soda', 'Energy Drinks', 'Bottled Water', 'Instant Coffee'],
    'Ready-to-Eat Meals': ['Instant Noodles', 'Canned Food', 'Microwave Meals'],
    'Household Essentials': ['Cleaning Supplies', 'Tissues & Paper Towels', 'Trash Bags', 'Laundry Detergent'],
    'Personal Care Basics': ['Toothpaste', 'Razors', 'Hand Soap', 'Sanitary Products'],
    'Health & First Aid': ['Pain Relievers', 'Bandages', 'Hand Sanitizer']
  },
  'Handmade & Artisan Products': {
    'Handmade Jewelry': ['Beaded Jewelry', 'Silver Jewelry', 'Handmade Bangles'],
    'Handmade Home Décor': ['Wall Hangings', 'Macramé', 'Handmade Candles'],
    'Pottery & Ceramics': ['Mugs & Bowls', 'Vases', 'Decorative Plates'],
    'Handmade Textiles': ['Embroidered Items', 'Handwoven Rugs', 'Quilts & Throws'],
    'Artisan Food & Soaps': ['Homemade Jams & Pickles', 'Handmade Soaps', 'Artisan Honey'],
    'Woodwork & Leather Goods': ['Wooden Crafts', 'Leather Wallets', 'Leather Bags']
  }
};

/** A suggested category: a sub category (parent null) or one of its products (parent = the sub category). */
export interface SuggestedCategory {
  name: string;
  parent: string | null;
}

/** Variant options suggested for each industry, added after the recommended ones. */
export const INDUSTRY_VARIANT_SUGGESTIONS: { [industry: string]: string[] } = {
  'Fashion & Clothing': ['Size', 'Color', 'Fit', 'Neck Size', 'Sleeve Length', 'Waist Size', 'Inseam Length', 'Length', 'Fabric']
};

/** Shopify's size entries, offered for Fashion & Clothing categories and their sub categories or products. */
export const FASHION_SIZE_VALUES: ReadonlyArray<string> = [
  'L', 'M', 'S', '3XS', '2XS', 'XS', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL', '7XL', '8XL',
  '0', '00', '000', '1', '2', '4', '6', '8', '10', '12', '14', '16', '18', '20', '22', '24', '26', '28', '30',
  '32', '34', '36', '38', '40', '42', '44', '46', '48', '50', '52', '54', '56', '58', '60',
  '0-3 months', '3-6 months', '6-9 months', '9-12 months', '12-18 months', '18-24 months',
  '2T', '3T', '4T', '5T', '6T', '0X', '1X', '2X', '3X', '4X', '5X', '6X',
  '2-3 years', '3-4 years', '4-5 years', '5-6 years', '6-7 years', '7-8 years', '8-9 years',
  '9-10 years', '10-11 years', '11-12 years', '12-13 years', '13-14 years', 'One size', 'Other'
];

/** Shopify's fabric entries, offered for Fashion & Clothing categories and their sub categories or products. */
export const FASHION_MATERIAL_VALUES: ReadonlyArray<string> = [
  'Cotton', 'Acrylic', 'Angora', 'Bamboo', 'Canvas', 'Cashmere', 'Corduroy', 'Cork', 'Denim', 'Faux fur',
  'Faux leather', 'Felt', 'Flannel', 'Fleece', 'Fur', 'Hemp', 'Jute', 'Latex', 'Leather', 'Linen', 'Lycra',
  'Lyocell', 'Merino', 'Mesh', 'Modal', 'Mohair', 'Neoprene', 'Nylon', 'Plastic', 'Plush', 'Polyester',
  'Rattan', 'Rayon', 'Rubber', 'Satin', 'Sherpa', 'Silk', 'Suede', 'Synthetic', 'Terrycloth', 'Tweed',
  'Twill', 'Velour', 'Velvet', 'Vinyl', 'Viscose', 'Wool', 'Other'
];

/** Variant options offered for Fashion & Clothing categories, and the values each one takes (keyed by option name). */
export const FASHION_VARIANT_VALUES: { [option: string]: string[] } = {
  Fit: ['Slim', 'Regular', 'Relaxed', 'Skinny leg', 'Boyfriend', 'Mom', 'Straight leg', 'Tapered leg', 'Wide', 'Other'],
  'Neck Size': ['14', '14.5', '15', '15.5', '16', '16.5', '17'],
  'Sleeve Length': ['Short', 'Long', '32', '33', '34', '35', '3/4', 'Cap', 'Sleeveless', 'Spaghetti strap', 'Strapless', 'Other'],
  'Waist Size': ['28', '30', '32', '34', '36', '38', '40'],
  'Inseam Length': ['28', '30', '32', '34'],
  Length: ['Mini', 'Knee', 'Midi', 'Maxi']
};

/** Variant option names offered in the Recommended list for Fashion & Clothing categories. */
export const FASHION_VARIANT_NAMES: ReadonlyArray<string> = Object.keys(FASHION_VARIANT_VALUES);

/** Shopify's shoe size entries, offered for Shoes & Footwear categories. */
export const SHOE_SIZE_VALUES: ReadonlyArray<string> = [
  'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '7XL', '8XL',
  '0', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5',
  '10', '10.5', '11', '11.5', '12', '12.5', '13', '13.5', '14', '14.5', '15', '15.5', '16', '16.5', '17', '17.5', '18', '18.5',
  '19', '19.5', '20', '20.5', '21', '21.5', '22', '22.5', '23', '23.5', '24', '24.5', '25', '25.5', '26', '26.5', '27', '27.5',
  '28', '28.5', '29', '29.5', '30', '30.5', '31', '31.5', '32', '32.5', '33', '33.5', '34', '34.5', '35', '35.5', '36', '36.5',
  '37', '37.5', '38', '38.5', '39', '39.5', '40', '40.5', '41', '41.5', '42', '42.5', '43', '43.5', '44', '44.5', '45', '45.5',
  '46', '46.5', '47', '47.5', '48', '48.5', '49', '49.5', '50', '50.5', '51', '51.5', '52', '52.5', '53', '53.5', '54', '54.5',
  '55', '55.5', '56', '56.5', '57', '57.5', '58', '58.5', '59', '59.5', '60', 'Other'
];

/** Shopify's footwear material entries, offered for Shoes & Footwear categories. */
export const SHOE_MATERIAL_VALUES: ReadonlyArray<string> = [
  'Canvas', 'Cotton', 'Faux fur', 'Faux leather', 'Fleece', 'Leather', 'Linen', 'Mesh', 'Neoprene', 'Nylon', 'Plastic',
  'Polyester', 'Polyvinyl chloride (PVC)', 'Rubber', 'Satin', 'Silk', 'Spandex', 'Suede', 'Synthetic',
  'Thermoplastic polyurethane (TPU)', 'Wool', 'Other'
];

/** Gender entries for Fashion & Clothing categories (Shopify's list). */
export const FASHION_GENDER_VALUES: ReadonlyArray<string> = ['Female', 'Male', 'Unisex', 'Other'];

/** Gender entries for Jewelry & Accessories categories (the jewelry sheet, plus Shopify's target gender list). */
export const JEWELRY_GENDER_VALUES: ReadonlyArray<string> = ['Men', 'Women', 'Unisex', 'Female', 'Male', 'Other'];

/** Gender entries for Shoes & Footwear categories (from the shoe sheet, plus Unisex and Other). */
export const SHOE_GENDER_VALUES: ReadonlyArray<string> = ['Men', 'Women', 'Kids', 'Unisex', 'Other'];

/** Variant options offered for Shoes & Footwear categories, and the values each one takes (keyed by option name). */
export const SHOE_VARIANT_VALUES: { [option: string]: string[] } = {
  'Size System': ['US', 'UK', 'EU'],
  Width: ['Narrow', 'Regular', 'Wide'],
  'Heel Height': ['Low', 'Mid', 'High', 'Flat', 'Very high', 'Other'],
  Closure: [
    'Lace-Up', 'Slip-On', 'Velcro', 'Adjustable straps', 'Adjustable/Pull', 'Buckles', 'Buttons', 'Clasp', 'Clip-on',
    'Drawstring', 'Elastic', 'Hook & eye', 'Hook & loop', 'Magnetic', 'None', 'Screw-on', 'Straps', 'Ties', 'Toggle',
    'Zipper', 'Snap', 'Other'
  ]
};

/** Variant option names offered in the Recommended list for Shoes & Footwear categories. */
export const SHOE_VARIANT_NAMES: ReadonlyArray<string> = Object.keys(SHOE_VARIANT_VALUES);

/** True when the category is Shoes & Footwear itself, one of its sub categories, or one of their products. */
export function isShoesCategory(categoryName: string | null | undefined): boolean {
  const wanted = String(categoryName || '').trim().toLowerCase();
  if (!wanted) return false;
  const shoes = INDUSTRY_CATEGORY_SUGGESTIONS['Shoes & Footwear'];
  if (wanted === 'shoes & footwear') return true;
  return Object.keys(shoes).some((subCategory) =>
    subCategory.toLowerCase() === wanted || shoes[subCategory].some((product) => product.toLowerCase() === wanted)
  );
}

/** Material entries for Mobile & Tech Accessories categories (Shopify's list, plus the sheet's Silicone and TPU). */
export const MOBILE_MATERIAL_VALUES: ReadonlyArray<string> = [
  'Acrylic', 'Aluminum', 'Angora', 'Bamboo', 'Biodegradable materials', 'Brass', 'Bronze', 'Canvas', 'Carbon', 'Cardboard',
  'Cashmere', 'Ceramic', 'Chrome', 'Clay', 'Coir', 'Concrete', 'Copper', 'Corduroy', 'Cork', 'Cotton', 'Denim', 'Fabric',
  'Faux fur', 'Faux leather', 'Felt', 'Fiberglass', 'Flannel', 'Fleece', 'Fur', 'Glass', 'Graphite', 'Hemp', 'Iron', 'Jute',
  'Latex', 'Leather', 'Linen', 'Lycra', 'Lyocell', 'Marble', 'Silicone', 'TPU'
];

/** Material entries for Jewelry & Accessories categories (Shopify's jewelry material list). */
export const JEWELRY_MATERIAL_VALUES: ReadonlyArray<string> = [
  'Acrylic', 'Alcantara', 'Alloy', 'Aluminum', 'Bakelite', 'Bamboo', 'Black rhodium-plated', 'Brass', 'Bronze', 'Bronze-plated',
  'Carbon fiber', 'Ceramic', 'Chrome', 'Copper', 'Copper-plated', 'Cordura', 'Cork', 'Cotton', 'Diamond', 'Duralumin', 'Enamel',
  'Fabric', 'Faux fur', 'Faux leather', 'Felt', 'Fiberglass', 'Fur', 'Glass', 'Gold', 'Gold-plated', 'Hemp', 'Iron', 'Jute',
  'Latex', 'Leather', 'Linen', 'Marble', 'Mesh', 'Metal', 'Microfiber', 'Nickel', 'Nickel-plated', 'Non-precious metals',
  'Nylon', 'Palladium', 'Palladium-plated', 'Pearls', 'Plastic', 'Platinum', 'Platinum-plated', 'Polyester', 'Porcelain',
  'Precious resin', 'Precious/Semiprecious stones', 'Red gold', 'Resin', 'Rhodium-plated', 'Rose gold', 'Rose gold-plated',
  'Rubber', 'Satin', 'Silk', 'Silver', 'Silver-plated', 'Stainless steel', 'Sterling silver', 'Suede', 'Synthetic', 'Tin-plated',
  'Titanium', 'Velvet', 'Vinyl', 'White gold', 'White gold-plated', 'Wood', 'Wool', 'Other'
];

/** Variant options offered for Beauty & Cosmetics categories, and the values each one takes (keyed by option name). */
export const BEAUTY_VARIANT_VALUES: { [option: string]: string[] } = {
  Shade: [
    'Beige', 'Blue', 'Brown', 'Deep beige', 'Deep brown', 'Gold', 'Green', 'Light beige', 'Light gold', 'Light peach',
    'Light pink', 'Light rose gold', 'Medium beige', 'Medium gold', 'Medium peach', 'Medium pink', 'Medium rose gold',
    'Multicolor', 'Natural', 'Peach', 'Pink', 'Purple', 'Red', 'Rose gold', 'Silver', 'Tan beige', 'Tan brown', 'White',
    'Yellow', 'Other', 'Light', 'Medium', 'Dark', 'Nude'
  ],
  'Size / Volume': ['30 ml', '50 ml', '100 ml', '250 ml'],
  Scent: ['Unscented', 'Floral', 'Fresh', 'Woody'],
  'Skin Type': ['Normal', 'Dry', 'Oily', 'Combination', 'Sensitive'],
  'Hair Type': ['Straight', 'Wavy', 'Curly', 'Dry', 'Oily'],
  Finish: ['Matte', 'Satin', 'Glossy'],
  'Pack Size': ['1', '2', '3'],
  'Skin tone': [
    'All skin tones', 'Cafe skin', 'Dark skin', 'Deep skin', 'Fair skin', 'Light skin', 'Medium skin', 'Nude skin',
    'Sand skin', 'Tanned skin', 'Other'
  ]
};

/** Variant option names offered in the Recommended list for Beauty & Cosmetics categories. */
export const BEAUTY_VARIANT_NAMES: ReadonlyArray<string> = Object.keys(BEAUTY_VARIANT_VALUES);

/** Variant options offered for Nutrition & Wellness categories, and the values each one takes (keyed by option name). */
export const NUTRITION_VARIANT_VALUES: { [option: string]: string[] } = {
  Flavor: [
    'Chocolate', 'Vanilla', 'Strawberry', 'Unflavored', 'Almond', 'Apple', 'Banana', 'Blueberry', 'Caramel', 'Cherry',
    'Cinnamon', 'Coconut', 'Coffee', 'Dulce de leche', 'Elderflower', 'Ginger', 'Lemon', 'Lime', 'Lychee', 'Mango',
    'Matcha', 'Mint', 'Mojito', 'Orange', 'Peach', 'Raspberry', 'Rose', 'Salted caramel', 'Tropical', 'Other'
  ],
  'Size / Weight': ['1 lb', '2 lb', '5 lb', '500 g', '1 kg'],
  'Pack Size': ['6', '12', '24'],
  Servings: ['30', '60', '90'],
  Form: [
    'Powder', 'Bar', 'Liquid', 'Capsule', 'Cream', 'Cream-to-powder', 'Film', 'Foam', 'Foaming lotion', 'Gel', 'Kohl',
    'Loose powder', 'Lotion', 'Milk', 'Mousse', 'Oil', 'Ointment', 'Pads', 'Paste', 'Pencil', 'Pressed powder', 'Roll-on',
    'Serum', 'Solid', 'Spray', 'Stick', 'Suppository', 'Tablets', 'Towelette', 'Wipes', 'Other'
  ],
  'Dietary Type': ['Vegan', 'Gluten-Free', 'Sugar-Free', 'Organic']
};

/** Variant option names offered in the Recommended list for Nutrition & Wellness categories. */
export const NUTRITION_VARIANT_NAMES: ReadonlyArray<string> = Object.keys(NUTRITION_VARIANT_VALUES);

/** True when the category is Nutrition & Wellness itself, one of its sub categories, or one of their products. */
export function isNutritionCategory(categoryName: string | null | undefined): boolean {
  const wanted = String(categoryName || '').trim().toLowerCase();
  if (!wanted) return false;
  const nutrition = INDUSTRY_CATEGORY_SUGGESTIONS['Nutrition & Wellness'];
  if (wanted === 'nutrition & wellness') return true;
  return Object.keys(nutrition).some((subCategory) =>
    subCategory.toLowerCase() === wanted || nutrition[subCategory].some((product) => product.toLowerCase() === wanted)
  );
}

/** True when the category is Beauty & Cosmetics itself, one of its sub categories, or one of their products. */
export function isBeautyCategory(categoryName: string | null | undefined): boolean {
  const wanted = String(categoryName || '').trim().toLowerCase();
  if (!wanted) return false;
  const beauty = INDUSTRY_CATEGORY_SUGGESTIONS['Beauty & Cosmetics'];
  if (wanted === 'beauty & cosmetics') return true;
  return Object.keys(beauty).some((subCategory) =>
    subCategory.toLowerCase() === wanted || beauty[subCategory].some((product) => product.toLowerCase() === wanted)
  );
}

/** True when the category is Fashion & Clothing itself, one of its sub categories, or one of their products. */
export function isFashionCategory(categoryName: string | null | undefined): boolean {
  const wanted = String(categoryName || '').trim().toLowerCase();
  if (!wanted) return false;
  const fashion = INDUSTRY_CATEGORY_SUGGESTIONS['Fashion & Clothing'];
  if (wanted === 'fashion & clothing') return true;
  return Object.keys(fashion).some((subCategory) =>
    subCategory.toLowerCase() === wanted || fashion[subCategory].some((product) => product.toLowerCase() === wanted)
  );
}

/** Shopify colour entries missing from the product colour list. Patterns have no hex, so they use a neutral swatch. */
export const SHOPIFY_COLOR_VALUES: ReadonlyArray<{ name: string; hex: string }> = [
  { name: 'Rose gold', hex: '#b76e79' },
  { name: 'Animal', hex: '#9ca3af' },
  { name: 'Camouflage', hex: '#9ca3af' },
  { name: 'Checkered', hex: '#9ca3af' },
  { name: 'Dots', hex: '#9ca3af' },
  { name: 'Floral', hex: '#9ca3af' },
  { name: 'Geometric', hex: '#9ca3af' },
  { name: 'Multicolor', hex: '#9ca3af' },
  { name: 'Plaid', hex: '#9ca3af' },
  { name: 'Rainbow', hex: '#9ca3af' },
  { name: 'Striped', hex: '#9ca3af' },
  { name: 'Tie-dye', hex: '#9ca3af' }
];

/** Variant options for the business's industry; none when the industry is unset or has no variant data. */
export function suggestedVariantOptions(industryRaw: string | null | undefined): string[] {
  const wanted = industryName(industryRaw).toLowerCase();
  const matched = Object.keys(INDUSTRY_VARIANT_SUGGESTIONS).find((name) => name.toLowerCase() === wanted);
  return matched ? [...INDUSTRY_VARIANT_SUGGESTIONS[matched]] : [];
}

/** The industry name without the " || description" suffix the business setup can append. */
export function industryName(industryRaw: string | null | undefined): string {
  return String(industryRaw || '').split(' || ')[0].trim();
}

/**
 * Categories suggested for the business's industry that it does not already have, matched by name ignoring case.
 * Each sub category is followed by its products, which are also selectable. Each name appears once.
 * The business type is optional: when the industry is unset or unknown, suggestions come from every industry.
 */
export function suggestedCategories(
  industryRaw: string | null | undefined,
  existingCategoryNames: ReadonlyArray<string>
): SuggestedCategory[] {
  const wanted = industryName(industryRaw).toLowerCase();
  const matched = Object.keys(INDUSTRY_CATEGORY_SUGGESTIONS).find((name) => name.toLowerCase() === wanted);
  // The business's own industry comes first, then every other industry's categories (cross suggestions).
  const allIndustries = Object.keys(INDUSTRY_CATEGORY_SUGGESTIONS);
  const industries = matched ? [matched, ...allIndustries.filter((name) => name !== matched)] : allIndustries;

  const taken = new Set(existingCategoryNames.map((name) => String(name || '').trim().toLowerCase()));
  const suggestions: SuggestedCategory[] = [];
  const add = (name: string, parent: string | null) => {
    const key = name.toLowerCase();
    if (taken.has(key)) return;
    taken.add(key);
    suggestions.push({ name, parent });
  };
  industries.forEach((industry) => {
    const subCategories = INDUSTRY_CATEGORY_SUGGESTIONS[industry];
    Object.keys(subCategories).forEach((subCategory) => {
      add(subCategory, null);
      subCategories[subCategory].forEach((product) => add(product, subCategory));
    });
  });
  return suggestions;
}
